/**
 * Checks whether a value is neither `null` nor a primitive — i.e. whether its type is `"object"`.
 * Note: Since `typeof` on arrays, dates, regexes, and plain objects all return `"object"`, this also returns `true` for those types.
 *
 * @param value - The value to test.
 */
export const isObject = (value: unknown): value is Record<any, any> =>
  value !== null && typeof value === 'object';
/**
 * Checks whether a value is a callable JavaScript function.
 *
 * @param value - The value to test.
 */
export const isFunction = (value: unknown): value is (...args: any) => any => typeof value === 'function';

/**
 * Checks whether a value is a JavaScript string.
 *
 * @param value - The value to test.
 */
export const isString = (value: unknown): value is string => typeof value === 'string';
/**
 * Checks whether a value is a boolean (`true` or `false`).
 *
 * @param value - The value to test.
 */
export const isBoolean = (value: unknown): value is boolean => typeof value === 'boolean';
/**
 * Checks whether a value is a JavaScript number.
 * Note: This does not check that the number is finite — `NaN` and `Infinity` pass.
 *
 * @param value - The value to test.
 */
export const isNumber = (value: unknown): value is number => typeof value === 'number';
/**
 * Checks whether a value is `undefined`.
 * Note: Unlike some type checks in this file, this does not treat `null` as undefined — `null` returns `false`.
 *
 * @param value - The value to test.
 */
export const isUndef = (value: unknown): value is undefined => typeof value === 'undefined';

// not a typeUtil but i'm putting it here for now -nate
/**
 * Converts a string to title case: the first letter of each word is uppercased and the rest is lowercased.
 *
 * @param str - The string to convert.
 */
export const toTitle = (str: string): string => {
  return str.replace(/\w\S*/g, (txt) => {
    return txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase();
  });
};
